import {defineType} from 'sanity'

export const hsvaColor = defineType({
  title: 'Hue Saturation Value',
  name: 'hsvaColor',
  type: 'object',
  fields: [
    {name: 'h', type: 'number', title: 'Hue'},
    {name: 's', type: 'number', title: 'Saturation'},
    {name: 'v', type: 'number', title: 'Value'},
    {name: 'a', type: 'number', title: 'Alpha'},
  ],
})
